import React from 'react';
import Logo from './assets/logo-bolao-top-cropped.png';

const TermsOfService = ({ onBack }) => {
    return (
        <div className="flex flex-col min-h-screen text-slate-200 font-sans bg-slate-900">
            {/* Navigation */}
            <nav className="sticky top-0 z-50 w-full border-b border-slate-700 shadow-lg" style={{ background: 'rgba(30, 41, 59, 0.7)', backdropFilter: 'blur(10px)', paddingTop: 'env(safe-area-inset-top)' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-20">
                        <div className="flex-shrink-0 flex items-center cursor-pointer hover:opacity-80 transition-opacity" onClick={onBack}>
                            <img src={Logo} alt="Bolões Top" className="h-16 w-auto" />
                        </div>
                        <div>
                            <button
                                onClick={onBack}
                                className="text-slate-300 hover:text-white font-bold py-2 px-4 transition-colors"
                            >
                                Voltar
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-slate-800 rounded-2xl p-8 md:p-12 shadow-xl border border-slate-700">
                    <h1 className="text-3xl md:text-4xl font-bold text-white mb-8 border-b border-slate-700 pb-4">Termos de Serviço</h1>
                    <p className="text-slate-400 mb-8">Última atualização: 13 de abril de 2026</p>

                    <div className="space-y-8 text-slate-300 leading-relaxed">

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">1. Aceitação dos Termos</h2>
                            <p>
                                Ao acessar ou utilizar o BoloesTOP (“plataforma”), incluindo nosso site e aplicativo, você concorda com estes Termos de Serviço e com a nossa Política de Privacidade.
                            </p>
                            <p className="mt-2">
                                Caso não concorde com estes termos, recomendamos que não utilize a plataforma.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">2. Descrição do Serviço</h2>
                            <p>
                                O BoloesTOP é uma plataforma digital de entretenimento que permite aos usuários criar e participar de bolões esportivos, como futebol e Fórmula 1.
                            </p>
                            <p className="mt-2">
                                O serviço não envolve apostas com dinheiro real, sendo destinado exclusivamente para fins recreativos.
                            </p>
                            <p className="mt-2">
                                A plataforma pode ser alterada, suspensa ou descontinuada a qualquer momento, sem aviso prévio.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">3. Cadastro e Autenticação</h2>
                            <p>
                                Para utilizar determinadas funcionalidades, o usuário deverá criar uma conta, fornecendo informações como nome (ou apelido), e-mail e senha.
                            </p>
                            <p className="mt-2">
                                Também oferecemos a opção de autenticação por meio de serviços de terceiros, como o login com Google. Ao utilizar essa opção, podemos receber informações básicas do perfil do usuário, como nome e endereço de e-mail.
                            </p>
                            <p className="mt-2">
                                O usuário é responsável por manter a confidencialidade de suas credenciais de acesso.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">4. Uso da Plataforma</h2>
                            <p>
                                O usuário compromete-se a utilizar a plataforma de forma legal e ética. Não é permitido:
                            </p>
                            <ul className="list-disc pl-5 mt-2 space-y-1">
                                <li>Utilizar a plataforma para fins ilegais ou não autorizados</li>
                                <li>Tentar acessar sistemas ou áreas restritas sem permissão</li>
                                <li>Interferir no funcionamento da plataforma ou prejudicar outros usuários</li>
                            </ul>
                            <p className="mt-2">
                                O descumprimento destes termos poderá resultar na suspensão ou exclusão da conta.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">5. Privacidade e Proteção de Dados</h2>
                            <p>
                                O tratamento dos dados pessoais é realizado conforme descrito em nossa Política de Privacidade:
                            </p>
                            <p className="mt-1">
                                👉 <a href="https://boloestop.com.br/politica-privacidade" className="text-green-400 hover:text-green-300 transition-colors">https://boloestop.com.br/politica-privacidade</a>
                            </p>
                            <p className="mt-4">
                                O usuário pode solicitar a exclusão de seus dados a qualquer momento por meio de:
                            </p>
                            <p className="mt-1">
                                👉 <a href="https://boloestop.com.br/exclusao-dados" className="text-green-400 hover:text-green-300 transition-colors">https://boloestop.com.br/exclusao-dados</a>
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">6. Propriedade Intelectual</h2>
                            <p>
                                Todo o conteúdo da plataforma, incluindo textos, marcas, logotipos e layout, é de propriedade do BoloesTOP ou de seus licenciadores.
                            </p>
                            <p className="mt-2">
                                É proibida a reprodução ou uso sem autorização prévia.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">7. Limitação de Responsabilidade</h2>
                            <p>
                                A plataforma é fornecida “como está”, sem garantias de funcionamento ininterrupto ou livre de erros.
                            </p>
                            <p className="mt-2">
                                Na máxima extensão permitida por lei, o BoloesTOP não se responsabiliza por danos diretos ou indiretos decorrentes do uso da plataforma.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">8. Alterações nos Termos</h2>
                            <p>
                                Estes Termos podem ser atualizados periodicamente. A versão mais recente estará sempre disponível nesta página.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4">9. Contato</h2>
                            <p>
                                Em caso de dúvidas, entre em contato pelo e-mail:
                            </p>
                            <p className="mt-2 text-lg font-semibold text-green-400">
                                📧 contato@boloestop.com.br
                            </p>
                        </section>

                    </div>
                </div>
            </div>
            {/* Footer */}
            <footer className="bg-slate-950 border-t border-slate-800 pt-12 pb-8 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-600">
                        <p>&copy; 2026 Bolões Top. Todos os direitos reservados.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default TermsOfService;
